import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * One page of Deal Copilot (QAI-V2) organizations matching `keyword`, from
 * `/ads/org/search`. Callback-only; nothing is stored in Redux.
 */
const searchOrganizations = (keyword, limit, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            '/ads/org/search',
            keyword ? [keyword] : [],
            {
              params: {
                'request-id': reqId,
                limit: limit || 20,
                orgType: 'n_org',
                fetchUsers: false,
                app: 'QAI-V2',
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch organizations');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback('Failed to fetch organizations');
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch organizations');
    }
  };
};

export default searchOrganizations;
